const getTopLevelDomain = () => {
    const fullDomain = window.location.hostname;
    const parts = fullDomain.split('.');
    const topLevelDomain = parts.slice(-2).join('.');
    let separator = '.';

    if (topLevelDomain === 'localhost') {
        separator = '';
    }

    return `${separator}${topLevelDomain}`;
};

const setCookieForSubdomain = (name: string, value: string, maxAge = '') => {
    const domain = `domain=${getTopLevelDomain()}`;
    const sameSite = 'SameSite=None';
    const secure = 'Secure';
    const maxAgeAttr = maxAge ? `max-age=${maxAge}` : '';

    document.cookie = `${name}=${value};${domain};path=/;${sameSite};${secure};${maxAgeAttr}`;
};

export default setCookieForSubdomain;
